import React from 'react';
import { Box, Typography } from '@mui/material';
import BundleChip from './BundleChip';
import ForCoachingChip from './ForCoachingChip';
import StatusChip from './StatusChip';
import { Subscription } from '../hooks/useMarketplaceSubscriptions';
import SubscriptionHelper from '../SubscriptionHelper';

interface Props {
    subscription: Subscription;
}

export default function SubscriptionDetails({ subscription }: Props) {
    const renewalText = SubscriptionHelper.getRenewalText(subscription.status, subscription.nextBillingDate, subscription.isTrial, subscription.isProgram);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            justifyContent="center"
            flexShrink={0}
            textAlign="right"
            flex={1}
        >
            <Box display="flex" gap={1}>
                {subscription.isBundle && <BundleChip />}
                {subscription.isForCoaching && <ForCoachingChip />}
                <StatusChip subscription={subscription} />
            </Box>
            <Typography variant="subtitle2">
                {subscription.price}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontStyle="italic">
                + applicable taxes
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
                {renewalText || ' '}
            </Typography>
        </Box>
    );
}
